import { Platform } from "react-native";
import React from "react";
import { View } from "react-native";
import { usePolicyListing } from "@lib/hooks/policyScreen/usePolicyListing";
import {
  isOpaqueStripeDisabled,
  isGradientAllowed,
  ScreenNameList,
} from "@lib/utilities/Constants";
import { ids, styles } from "./style";
import { Header } from "../../components/header/Header";
import PolicyList from "../../components/policyListing/PolicyList";
import { getBackgroundColor } from "@lib/utilities/HelperFunctions";
import commonStyle from "../../assets/styles/common-style";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import MainContainer from "../../components/common/MainContainer";
import GradientBackground from "../../components/gradient-background/GradientBackground";
import CommonStyle from "../../assets/styles/common-style";

const PolicyListing = ({ navigation }: any) => {
  const {
    isLoading,
    handlePolicySelection,
    showAlerts,
    errorData,
    onReloadPress,
    onEndTimer,
  } = usePolicyListing({ navigation });

  const Content = () => (
    <>
      {!isOpaqueStripeDisabled && (
        <View style={[styles.bgEffect]} dataSet={{ media: ids.bgEffect }} />
      )}
      <View style={styles.headerContainer}>
        <Header
          screenName={ScreenNameList.choosePolicy}
          navigation={navigation}
        />
      </View>

      {!isLoading && (
        <PolicyList
          handlePolicySelection={handlePolicySelection}
          showAlerts={showAlerts}
          isLoading={isLoading}
        />
      )}
      {!isOpaqueStripeDisabled && (
        <View
          style={[commonStyle.styles.bgEffectBottom]}
          dataSet={{ media: commonStyle.ids.bgEffectBottom }}
        />
      )}
    </>
  );

  if (isGradientAllowed && Platform.OS !== "web") {
    return (
      <MainContainer
        screenName={ScreenNameList.choosePolicy}
        navigation={navigation}
        errorData={errorData}
        onReloadPress={onReloadPress}
        onEndTimer={onEndTimer}
      >
        <GradientBackground
          styles={[CommonStyle.styles.coverImage, styles.mainView]}
        >
          {Content()}
        </GradientBackground>
      </MainContainer>
    );
  }

  return (
    <MainContainer
      screenName={ScreenNameList.choosePolicy}
      navigation={navigation}
      errorData={errorData}
      onReloadPress={onReloadPress}
      onEndTimer={onEndTimer}
    >
      <View
        style={[
          styles.mainView,
          {
            backgroundColor: getBackgroundColor(ScreenNameList.billingPayments),
          },
          isGradientAllowed && styles.gradientBg,
        ]}
      >
        {Content()}
      </View>
    </MainContainer>
  );
};

export default Platform.OS == "web"
  ? withAuthenticationRequired(PolicyListing)
  : PolicyListing;
